import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaCheckCircle } from "react-icons/fa";

const ThankYou = ({ redirectUrl = "/", timer = 10 }) => {
  const navigate = useNavigate();
  const [timeLeft, setTimeLeft] = useState(timer);

  useEffect(() => {
    const submitted = sessionStorage.getItem("formSubmitted");
    if (!submitted) {
      navigate("/", { replace: true });
    }
  }, [navigate]);

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          sessionStorage.removeItem("formSubmitted");
          navigate(redirectUrl, { replace: true });
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [navigate, redirectUrl]);

  return (
    <div className="pt-24 w-full h-screen flex justify-center items-center bg-gradient-to-r from-blue-100 to-blue-400 px-4 relative text-center">
      
      {/* Timer */}
<div className="absolute top-28 left-4 z-50 bg-white border border-gray-400 rounded px-3 py-1 text-sm font-semibold text-gray-700">
  {timeLeft}s
</div>

{/* Close */}
<button
  onClick={() => {
    sessionStorage.removeItem("formSubmitted");
    navigate(redirectUrl, { replace: true });
  }}
  className="absolute top-28 right-4 z-50 w-8 h-8 border border-gray-400 rounded-full font-bold hover:border-black"
>
  X
</button>


      <div className="flex flex-col items-center">
        <FaCheckCircle className="text-green-700 text-6xl mb-4" />
        <h2 className="font-bold text-4xl mb-4">Thank you!</h2>
        <p className="text-lg font-semibold max-w-xl">
          Your submission has been received. We will contact you soon.
        </p>
      </div>
    </div>
  );
};

export default ThankYou;
